import { useState, useEffect } from "react";
import { Button, Input, Modal, Checkbox, Upload, List } from "antd";
import CustomButton from "../AccommodationData/CustomButton/CustomButton";
import { UploadOutlined, SearchOutlined } from "@ant-design/icons";
import "./EmailModal.scss";
import { getAllCompanyRegistrations } from "../../services/RegistrationService";
import { getAllParticipants } from "../../services/ParticipantService";
import { sendEmailNotification } from "../../services/EmailNotificationsService";
import TagInput from "antd-tag-input";
import { getAllInvoices } from "../../services/InvoiceService";
import { getAllEvents } from "../../services/EventService";
import { AxiosResponse } from "axios";

const EmailModal = (props: any) => {
  const { TextArea } = Input;
  const CheckboxGroup = Checkbox.Group;
  const [imageArray, setImageArray] = useState<any>([]);
  const [checkboxArray, setCheckboxArray] = useState<any>([]);
  const [checked, setChecked] = useState<any>([]);
  const [indeterminate, setIndeterminate] = useState(false);
  const [checkAll, setCheckAll] = useState(false);
  const [show, setShow] = useState(false);
  const [listData, setListData]: any = useState([""]);
  const [emailArray, setEmailArray] = useState<any>([]);
  const [allData, setAllData] = useState<any>([]);
  const [searchValue, setSearchValue] = useState("");
  const [filteredList, setFilteredList] = useState([]);
  const [data, setData] = useState<any[]>([]);
  const [dataLegal, setDataLegal] = useState<any[]>([]);
  const [errorSubject, setErrorSubject] = useState(false);
  const [activeEvents, setActiveEvents] = useState<string[]>([]);
  const [checkedEvents, setCheckedEvent] = useState<string[]>([]);

  useEffect(() => {
    getAllEvents().then((res: AxiosResponse) => {
      setActiveEvents(res.data.result.map((event: any) => event.name));
    });
  }, []);

  useEffect(() => {
    getAllInvoices(true).then((response) => {
      const inovices = response.data.result;

      let filter = inovices?.filter(
        (inovice: any) => inovice.isCompany == true
      );

      const recipients: any = {};

      filter
        .filter(
          (legal: any) =>
            checkedEvents.includes(legal?.registrationCompany?.event?.name) // Proverava da li učesnik pripada izabranom eventu
        )
        .forEach((information: any) => {
          const email = information.email;
          if (!recipients.hasOwnProperty(email) && email) {
            recipients[email] = information.companyName;
          }
        });

      const filteredData = Object.keys(recipients).map((email) => ({
        email,
        name: recipients[email],
      }));

      setDataLegal(filteredData);
    });

    getAllParticipants().then((response) => {
      const recipients: any = {};
      const participants = response.data.result;

      participants
        .filter(
          (participant: any) => checkedEvents.includes(participant.event?.name) // Proverava da li učesnik pripada izabranom eventu
        )
        .forEach((participant: any) => {
          const email = participant.email;
          if (!recipients.hasOwnProperty(email)) {
            recipients[email] =
              participant.firstName + " " + participant.lastName;
          }
        });

      const filteredData = Object.keys(recipients).map((email) => ({
        email,
        name: recipients[email],
      }));

      setData(filteredData);
    });
  }, [checkedEvents]);

  const options = [
    {
      label: `Svim učesnicima - ${data.length}`,
      value: `Svim učesnicima - ${data.length}`,
    },
    {
      label: `Svim pravnim licima - ${dataLegal.length}`,
      value: `Svim pravnim licima - ${dataLegal.length}`,
    },
  ];

  useEffect(() => {
    if (searchValue) {
      return setFilteredList(
        listData.filter((item: any) => {
          return (
            item.email.toUpperCase().indexOf(searchValue.toUpperCase()) !== -1
          );
        })
      );
    } else {
      return setFilteredList(listData);
    }
  }, [searchValue, listData]);

  useEffect(() => {
    setCheckAll(false);
    setChecked([]);
    if (checkboxArray.length === 0) {
      return setListData([""]);
    }
    if (checkboxArray.length > 1) {
      return setListData([...dataLegal, ...data]);
    } else {
      if (checkboxArray.includes(`Svim pravnim licima - ${dataLegal.length}`)) {
        return setListData(dataLegal);
      }
      if (checkboxArray.includes(`Svim učesnicima - ${data.length}`)) {
        return setListData(data);
      }
    }
  }, [checkboxArray]);

  useEffect(() => {
    let dataChecked: any = [];
    if (checked.length !== 0) {
      dataChecked = checked;
    }
    setIndeterminate(checked.length && checked.length !== filteredList?.length);
    setCheckAll(checked.length === filteredList?.length);
    setAllData({ ...allData, selected: [...emailArray, ...dataChecked] });
  }, [checked]);

  useEffect(() => {
    let dataChecked: any = [];
    if (checked.length !== 0) {
      dataChecked = checked;
    }

    const newArray = emailArray.map((el: any) => {
      return { email: el };
    });

    setAllData({ ...allData, selected: [...newArray, ...dataChecked] });
  }, [emailArray]);

  const onSearch = (e: any) => {
    setSearchValue(e.target.value);
  };

  const handleDescription = (e: any) => {
    setAllData({ ...allData, content: e.target.value });
  };

  const handleSubject = (e: any) => {
    setErrorSubject(false);
    setAllData({ ...allData, subject: e.target.value });
  };

  const onCheckAllChange = (e: any) => {
    setChecked(e.target.checked ? filteredList?.map((item: any) => item) : []);
    setCheckAll(e.target.checked);
  };

  const handleCheck = (title: any) => {
    const filteredData = checked.filter((el1: any) => {
      if (el1 !== title) {
        return el1;
      }
    });

    if (filteredData.length < checked.length) {
      setChecked(filteredData);
    } else {
      setChecked([...checked, title]);
    }
  };

  const handleCheckbox = (e: any) => {
    if (e.length === 0) {
      setShow(false);
    } else {
      setShow(true);
    }

    setCheckboxArray(e);
  };

  const handleUpload = async (e: any) => {
    const files = e.fileList;
    if (files.length <= 0) return;

    setImageArray(files);
  };

  const handleSendEmailButton = async () => {
    if (!allData.subject) {
      setErrorSubject(true);
      return props.toast?.current?.show({
        severity: "error",
        detail: `Unesite naslov!`,
        life: 3000,
      });
    }
    sendEmailNotification(
      allData.subject,
      allData.content,
      allData.selected,
      imageArray
    )
      .then(() => {
        props.toast?.current?.show({
          severity: "success",
          detail: `Email obaveštenje je poslato!`,
          life: 3000,
        });
        props.handleEmailButton();
      })
      .catch(() => {
        props.toast?.current?.show({
          severity: "error",
          detail: `Email obaveštenje nije poslato!`,
          life: 3000,
        });
        props.handleEmailButton();
      });
  };

  const beforeUpload = (file: any) => {
    return false;
  };

  const onCheckEvent = (e: any, eventName: string) => {
    if (e.target.checked) {
      let arr = checkedEvents.find((name) => name == eventName);
      if (!arr) {
        setCheckedEvent([...checkedEvents, eventName]);
      }
    } else {
      let copyArr = [...checkedEvents];
      let newA = copyArr.filter((name) => name !== eventName);
      setCheckedEvent(newA);
    }
  };

  return (
    <Modal
      maskClosable={false}
      open={props.showEmailModal}
      title={`E-mail obaveštenje`}
      className={!show ? "email-modal small-width" : "email-modal large-width"}
      onCancel={() => {
        props.handleEmailButton();
      }}
      onOk={() => {
        props.handleEmailButton();
      }}
      footer={[
        <Button
          key={1}
          onClick={() => {
            props.handleEmailButton();
          }}
        >
          Odustani
        </Button>,
        <CustomButton
          danger={false}
          htmlType={"submit"}
          type={"primary"}
          key={2}
          function={() => {
            handleSendEmailButton();
          }}
          text={"Pošalji"}
        />,
      ]}
    >
      <div className="box">
        {!show ? null : (
          <div
            style={{
              minWidth: !show ? "0" : "300px",
            }}
            className="list-container"
          >
            {searchValue.length === 0 && (
              <Checkbox
                indeterminate={indeterminate}
                onChange={onCheckAllChange}
                className="check-all"
                checked={checkAll}
              >
                <p className="checkbox-all-text">{`selektuj sve (${filteredList.length})`}</p>
              </Checkbox>
            )}
            <Input
              className="search-field"
              placeholder="Pretražite"
              onChange={(e) => onSearch(e)}
              suffix={<SearchOutlined />}
            />
            <div className="inner-list">
              <CheckboxGroup style={{ width: "100%" }} value={checked}>
                <List
                  dataSource={filteredList}
                  renderItem={(item: any) => (
                    <List.Item>
                      <List.Item.Meta
                        avatar={
                          <Checkbox
                            onChange={(e: any) => handleCheck(item)}
                            value={item}
                          />
                        }
                        title={item.email}
                      />
                    </List.Item>
                  )}
                />
              </CheckboxGroup>
            </div>
          </div>
        )}
        <div className="modal-container">
          <div className="checkbox-group" style={{ marginBottom: "20px" }}>
            <p></p>
            <div>
              {activeEvents?.map((eventName) => {
                return (
                  <>
                    <Checkbox
                      onChange={(e) => {
                        onCheckEvent(e, eventName);
                      }}
                      className="check-all"
                      //checked={checkAll}
                    >
                      <p className="checkbox-all-text">{eventName}</p>
                    </Checkbox>
                  </>
                );
              })}
            </div>
          </div>
          <div className="checkbox-group">
            <CheckboxGroup
              value={checkboxArray}
              options={options}
              onChange={handleCheckbox}
            />
          </div>
          <TagInput
            value={emailArray}
            style={{ marginTop: "10px" }}
            placeholder="Unesite e-mail"
            onChange={(strArr) => setEmailArray(strArr)}
          />

          <Input
            type="text"
            className={errorSubject ? "input-label error" : "input-label"}
            placeholder="Unesite naslov"
            onChange={handleSubject}
          />
          <TextArea
            onChange={handleDescription}
            className="textarea"
            rows={4}
            placeholder="Unesite tekst"
          />
          <p className="text">
            <span className="required">*</span>Dodajte prilog:
          </p>
          <Upload
            multiple
            beforeUpload={beforeUpload}
            accept="*"
            onChange={handleUpload}
            action=""
            listType="text"
            className="upload"
            showUploadList={true}
          >
            <Button icon={<UploadOutlined />}>Click to Upload</Button>
          </Upload>
        </div>
      </div>
    </Modal>
  );
};

export default EmailModal;
